module.exports = __webpack_public_path__ + "files/29d1bec14cd7eefb1d6297cfaa1eeac5.png";